export default __webpack_public_path__ + "static/media/unnamed.2cb12904.png";